<template>
  <div id="app">
    <router-view/>
    <!-- 全局客服 -->
    <CustomerService />
  </div>
</template>
<script>
import CustomerService from "@/components/CustomerService/index.vue";
export default {
  name: "App",
  components: {
    CustomerService
  } 
};
</script>
<style lang="scss">
html,body,h1,h2,h3,h4,h5,h6,p,ul,li{
  margin: 0;
  padding: 0;
}

html,
body,
#app {
  width: 100%;
  min-height: 100%;
}
</style>
